<template>
  <div
    class="wf-product-room-scene-viewer wf-product-quick-view-modal justify-content-around"
    :class="isRug && viewMode === 'swatch' ? 'rug-image' : ''"
  >
    <!-- Swatch view mode controls -->
    <template v-if="viewMode === 'swatch'">
      <button
        class="btn wf-product-room-scene-viewer-button-close"
        type="button"
        @click="setViewMode"
      >
        <span
          class="png-icon png-icon-icons-glyph--k-close"
          aria-label="Close view mode 'swatch'"
        />
      </button>

      <!-- Plus Icon -->
      <button
        class="btn wf-product-room-scene-viewer-button-plus p-0 shadow"
        type="button"
        @click="zoomIn"
      >
        <span
          class="
              plus-sm-icon
              png-icon
              png-icon-icons-glyph--red-plus-sm
              wf-product-refinement-list-header-toggle-inactive
            "
        />
      </button>

      <!-- Minus Icon  -->
      <button
        class="btn wf-product-room-scene-viewer-button-minus p-0 shadow"
        type="button"
        @click="zoomOut"
      >
        <span
          class="
              plus-sm-icon
              png-icon
              png-icon-icons-glyph--red-minus-sm
              wf-product-refinement-list-header-toggle-inactive
            "
        />
      </button>
    </template>

    <slot></slot>
  </div>
</template>

<script>
export default {
  props: ["viewMode", "isRug"],
  data() {
    return {
      zoomLevel: 0,
      maxZoomLevel: 3,
      minZoomLevel: -3
    };
  },
  mounted() {
    document.querySelectorAll('img').forEach(img => {
      img.addEventListener('dragstart', this.preventDrag);
    });
  },
  beforeDestroy() {
    document.querySelectorAll('img').forEach(img => {
      img.removeEventListener('dragstart', this.preventDrag);
    });
  },
  methods: {
    hideModal(name) {
      this.$modal.hide(name + "-modal");
    },
    setViewMode() {
      this.hideModal("show-swatch");
    },
    zoomIn() {
      if (this.zoomLevel < this.maxZoomLevel) {
        this.zoomLevel++;
        this.updateZoom();
      }
    },
    zoomOut() {
      if (this.zoomLevel > this.minZoomLevel) {
        this.zoomLevel--;
        this.updateZoom();
      }
    },
    updateZoom() {
      var elements = document.querySelectorAll(".zoomable");
      elements.forEach(function(element) {
        let scale = 1 + this.zoomLevel * 0.1;
        element.style.transform = "scale(" + scale + ")";
      }.bind(this));
    },
    preventDrag(event) {
      event.preventDefault();
    }
  }
};
</script>
